import React, { Component } from 'react';
 
export class Footer extends Component {
    displayName = Footer.name;

    render() {
        return (
            <footer className="footer">
                <div className="container-fluid">
                   
                    <div className="copyright">
                        &copy;
                        {new Date().getFullYear()}
                        , Powered by
                    <a href="http://www.synapsys.sg"> Synapsys Limited.</a> All Rights Reserved.
                </div>
                </div>
            </footer>
        );
    }
}
